import React from 'react';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import BoxWithIcon from "../atoms/ComponentBox/BoxWithIcon";
import { useLocation ,useNavigate} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../redux/permissionsSlice';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const Transport = () => {
  const names = ['Vehicle Booking', 'Tiffin Booking', 'Canteen Order'];
  const location = useLocation();
  const navigate = useNavigate();

  const permissions = useSelector(selectPermissions);
    const hasModulePermission = (moduleName) => {
      const modulePermission = permissions.find(
        permission => permission.ModuleName === moduleName
      );
      
      if (!modulePermission) return false;
  
      return (
        modulePermission.AddRec === "1" ||
        modulePermission.EditRec === "1" ||
        modulePermission.DeleteRec === "1" ||
        modulePermission.ViewRec === "1"
      );
    };
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container sx={{
        '& .MuiGrid-root': {
          width: 'calc(90% + 16px)'
        }
      }}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
          {hasModulePermission("Vehicle Booking") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Vehicle Booking"
            />)}
           {hasModulePermission("Tiffin Booking") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Tiffin Booking"
            />)}
           {hasModulePermission("Canteen Order") && (
            <BoxWithIcon
              totalCount={10}
              activeCount={10}
              inactiveCount={0}
              link="#"
              // link={{ pathname: '/' }}
              title="Canteen Order"
            />)}
          </Grid>
          <Grid container spacing={2} sx={{ mt: 1 }}>  
         
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}

export default Transport;